import React, { useState } from 'react';

interface ExpiryDatePickerProps {
  value: string;
  onChange: (expiryDate: string) => void;
}

type ExpiryOption = 'none' | '3months' | '6months' | '1year' | 'custom';

const ExpiryDatePicker: React.FC<ExpiryDatePickerProps> = ({ value, onChange }) => {
  const [option, setOption] = useState<ExpiryOption>('none');

  const handleOptionChange = (opt: ExpiryOption) => {
    setOption(opt);
    if (opt === 'none') {
      onChange('');
      return;
    }
    if (opt === 'custom') {
      return;
    }
    const date = new Date();
    if (opt === '3months') date.setMonth(date.getMonth() + 3);
    else if (opt === '6months') date.setMonth(date.getMonth() + 6);
    else if (opt === '1year') date.setFullYear(date.getFullYear() + 1);
    onChange(date.toISOString().split('T')[0]);
  };

  const options: { key: ExpiryOption; label: string }[] = [
    { key: 'none', label: 'No expiry' },
    { key: '3months', label: '3 months' },
    { key: '6months', label: '6 months' },
    { key: '1year', label: '1 year' },
    { key: 'custom', label: 'Custom date' },
  ];

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Auto-delete
      </label>
      <div className="flex flex-wrap gap-2">
        {options.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            onClick={() => handleOptionChange(key)}
            className={`px-3 py-1.5 rounded-md text-sm border transition-colors duration-150 ${
              option === key
                ? 'bg-church-blue text-white border-church-blue'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      {option === 'custom' && (
        <input
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          min={new Date(Date.now() + 86400000).toISOString().split('T')[0]}
          className="mt-2 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-church-blue"
        />
      )}
      {value && option !== 'none' && (
        <p className="text-sm text-gray-500 mt-1">
          File will be deleted on {new Date(value + 'T00:00:00').toLocaleDateString()}
        </p>
      )}
    </div>
  );
};

export default ExpiryDatePicker;
